/* The Saber Company - hold the cart drawer until its numbers agree.

   The line price is rendered instantly by Liquid (the synthesised birthday price),
   but the totals at the bottom come from assets/tsc-cart-totals.js, which reads
   Shopify's cart and therefore cannot show the discount until Discount Ninja has
   actually applied it. Measured on a $299.99 saber: the drawer opened at 2.07s
   showing "$210.00" on the line, the totals block appeared at 2.82s still saying
   "Total $299.99", and only then settled. That disagreement is the flicker.

   So after an add-to-cart, keep the drawer invisible until the totals carry a
   saving row - the proof that DN has applied - then reveal it in one piece.

   Display only. It never touches the cart, the gifts, the tokens or the totals;
   it only decides when the drawer becomes visible. Hard-capped so it can never
   hang, and it stands aside entirely for a drawer opened from the header. */
(function () {
  'use strict';
  if (window.tscCartSettle) return;
  window.tscCartSettle = true;

  var HOLD_MAX = 2200;   // never hold longer than this, whatever happens
  var MIN_HOLD = 120;    // below this a reveal reads as a flash, not a settle
  var ARM_MS   = 6000;   // how long after an add an open counts as "add-driven"

  var armedUntil = 0;
  var drawer = null;
  var holding = false;
  var releasedThisOpen = false;   // releasing mutates the class, which re-fires the
                                  // observer; without this it simply holds again
  var timers = [];

  function arm(target) {
    if (target && target.closest && !target.closest('form[action*="/cart/add"]')) return;
    armedUntil = Date.now() + ARM_MS;
    releasedThisOpen = false;
  }
  document.addEventListener('submit', function (e) { arm(e.target); }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[name="add"]') : null;
    if (btn) arm(btn);
  }, true);

  var style = document.createElement('style');
  style.id = 'tsc-cart-settle-style';
  style.textContent = 'cart-drawer.tsc-hold{opacity:0!important;pointer-events:none!important}';
  (document.head || document.documentElement).appendChild(style);

  /* Settled means the TOTAL agrees with the line prices, which only happens once
     DN's percentage discount has landed - not merely once the free gift has.
     Waiting on "any saving row" released too early: the gift row appears first,
     so the drawer revealed with "$210.00" on the line and "Total $299.99" below,
     which is the exact mismatch this is meant to hide. So look for a saving row
     that is NOT the gift. A cart that earns no percentage discount never produces
     one, and the cap is what releases that. */
  function settled() {
    var box = document.querySelector('.tsc-totals');
    if (!box) return false;
    var rows = box.querySelectorAll('.tsc-totals__row--saving');
    var hasDiscount = false;
    for (var i = 0; i < rows.length; i++) {
      var label = (rows[i].firstChild && rows[i].firstChild.textContent) || '';
      if (!/free gift/i.test(label)) hasDiscount = true;
    }
    /* Deliberately NOT waiting for the gift BOX LINE to render as well. Tried it:
       the repaint that brings the box into the list lands after the 2.2s cap, so the
       drawer sat hidden for the full cap (visible at ~3.7-4.2s instead of ~2.1s) and
       the line still was not there. A box sliding into the list a moment later is far
       less jarring than a four second wait, and the NUMBERS - which is what looked
       broken - are already correct at reveal. */
    return hasDiscount;
  }

  function clearTimers() {
    timers.forEach(function (t) { clearTimeout(t); clearInterval(t); });
    timers = [];
  }

  function release() {
    clearTimers();
    if (!holding) return;
    holding = false;
    releasedThisOpen = true;
    if (drawer) drawer.classList.remove('tsc-hold');
  }

  function hold() {
    if (holding || releasedThisOpen || !drawer) return;
    if (Date.now() > armedUntil) return;      // opened from the header - nothing to wait for
    holding = true;
    drawer.classList.add('tsc-hold');
    var start = Date.now();
    timers.push(setInterval(function () {
      if (settled() && Date.now() - start >= MIN_HOLD) release();
    }, 80));
    timers.push(setTimeout(release, HOLD_MAX));
  }

  function watch() {
    drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) hold();
      else { release(); releasedThisOpen = false; }   // closed: ready to hold the next open
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
